export const forgotPassword = {
    title: 'Забыли пароль',
    content: 'Пожалуйста, введите вашу зарегистрированную электронную почту',
    button: 'Отправить',
    titleSwal: 'Ссылка для сброса пароля отправлена',
    contentSwal: 'Пожалуйста, проверьте свою электронную почту и перейдите по ссылке для сброса пароля',
};
